import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";
import axios from "@/plugins/axios.js";
import { useRouter } from "vue-router";
import tracker from "@/plugins/openReplay";

export default createStore({
  state: {
    uid: "",
    idCheck: "N",
    userInfo: {
      accessToken: "",
      accessKey: "",
      uidx: "",
      kname: "",
      ename: "",
      email: "",
    },
    classData: {
      lessonState: 0,
    },
    autoLogin: false,
  },
  getters: {},
  mutations: {
    setAutoLogin(state, autoLogin) {
      state.autoLogin = autoLogin;
    },
    setIdCheck(state, idCheck) {
      state.idCheck = idCheck;
    },
    setUid(state, uid) {
      state.uid = uid;
    },
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo;
    },
    setLessonState(state, lesson_state) {
      state.classData.lessonState = lesson_state;
    },
    loginCheck: function (state) {
      const router = useRouter();
      const params = {
        uidx: state.userInfo.uidx,
        accessToken: state.userInfo.accessToken,
      };

      axios.get(`/rest/common/chkMemberToken`, { params }).then(
        (res) => {
          if (res.data.err === 0) {
            // openReplay에 사용자 설정을 한다.
            tracker.setUserID(state.userInfo.email);
            return;
          }

          alert(res.data.err_msg);
          state.userInfo = [];
          state.classData = {
            lessonState: 0,
          };
          router.push("/");
        },
        (error) => {
          console.log(error);
          state.userInfo = [];
          state.classData = {
            lessonState: 0,
          };
          router.push("/");
        }
      );
    },
    resetUserInfo(state) {
      state.userInfo = [];
      state.classData = {
        lessonState: 0,
      };
      state.autoLogin = false;
    },
  },
  actions: {},
  plugins: [createPersistedState()],
});
